module.exports = __webpack_public_path__ + "img/CNAS.259aa5af.png";